import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbTrail from '../../components/ui/BreadcrumbTrail';
import PaymentApprovalDashboard from './components/PaymentApprovalDashboard';

export default function PaymentProcessing() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Header
        onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        isMobileMenuOpen={isMobileMenuOpen}
      />

      <div className="flex">
        <div className="hidden lg:block">
          <Sidebar isCollapsed={isSidebarCollapsed} userRole="admin" isSuperAdmin={true} />
        </div>

        <main className={`flex-1 transition-layout ${isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
          <div className="p-4 lg:p-6 max-w-7xl mx-auto">
            <div className="mb-6">
              <BreadcrumbTrail />
            </div>

            <div className="mb-6">
              <h1 className="text-2xl lg:text-3xl font-semibold text-foreground mb-2">
                Payment Approval Dashboard
              </h1>
              <p className="text-sm text-muted-foreground">
                Review and approve subscription payments from group administrators
              </p>
            </div>

            <PaymentApprovalDashboard />
          </div>
        </main>
      </div>
    </div>
  );
}